module.exports = __webpack_public_path__ + "img/Réalisation brises vues.1394fb48.jpg";